import { DateNavigatorButton } from './date-navigator-button';
import { DateNavigatorButtonWithInput } from './date-navigator-button-with-input';
import { DateNavigatorProvider } from './date-navigator-provider';
import { DateNavigatorProps } from './date-navigator.types';
import { getButtonVariantCommonProps, getContainerProps, getDateNavigatorFieldProps } from './helpers';

export const DateNavigatorComponent = (props: DateNavigatorProps) => {
  const { variant = 'button-with-input' } = props;

  return (
    <DateNavigatorProvider {...getContainerProps(props)}>
      {variant === 'button-with-input' ? (
        <DateNavigatorButtonWithInput {...getDateNavigatorFieldProps(props)} />
      ) : variant === 'button' ? (
        <DateNavigatorButton {...getButtonVariantCommonProps(props)} />
      ) : null}
    </DateNavigatorProvider>
  );
};

export const DateNavigator = Object.assign(DateNavigatorComponent, {
  Provider: DateNavigatorProvider,
  ButtonWithInput: DateNavigatorButtonWithInput,
  Button: DateNavigatorButton,
});
